// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"ix_a bhh_sq","PhotoTitleEditForm__cancelBtn":"ix_b bhh_su bhh_st"};